import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, ENGAGEMENT_TYPE_ID, GOAL_TARGET_ID, LINE_ITEM_TYPE_ID, PRODUCT_TYPE_ID, QUOTE_TYPE_ID, TASK_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { AssociationCategoryTypesToIds } from 'customer-data-objects/associations/AssociationCategoryTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const getHref = (associationDefinition, objectId) => {
  const portalId = PortalIdParser.get();
  const toObjectTypeId = associationDefinition.toObjectTypeId;
  const associationCategoryNumber = AssociationCategoryTypesToIds[associationDefinition.associationCategory];
  const inverseAssociationTypeId = associationDefinition.inverseAssociationTypeId;
  const filters = encodeURIComponent(JSON.stringify([{
    operator: 'EQ',
    value: objectId,
    property: `associations.${associationCategoryNumber}-${inverseAssociationTypeId}`
  }]));
  let queryString = `filters=${filters}`;
  if (toObjectTypeId === DEAL_TYPE_ID) {
    queryString += '&pipelineId=all';
  }
  return `/contacts/${portalId}/objects/${toObjectTypeId}/views/all/list?${queryString}`;
};

// https://git.hubteam.com/HubSpot/crm-datasets-ui/issues/1716
const allowListObjectIds = new Set([CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID, ENGAGEMENT_TYPE_ID, TICKET_TYPE_ID, PRODUCT_TYPE_ID, LINE_ITEM_TYPE_ID, QUOTE_TYPE_ID, TASK_TYPE_ID, GOAL_TARGET_ID]);
const isSupportedHubSpotDefinedAssociation = associationDefinition => associationDefinition.associationCategory === 'HUBSPOT_DEFINED' && allowListObjectIds.has(associationDefinition.toObjectTypeId) && allowListObjectIds.has(associationDefinition.fromObjectTypeId);

/*
  This component is used to render a link to view all associated objects
  for a given object. It is used in the association popover and in the
  association column in the index page table.
*/
export const ViewAssociatedObjectsLink = ({
  associationDefinition,
  associatedObjectsCount,
  objectId
}) => {
  // https://git.hubteam.com/HubSpot/crm-datasets-ui/issues/1716

  const shouldRenderLink = isSupportedHubSpotDefinedAssociation(associationDefinition) || associationDefinition.associationCategory === 'USER_DEFINED';
  if (!shouldRenderLink) return null;
  const href = getHref(associationDefinition, objectId);
  const associationName = associatedObjectsCount > 1 ? associationDefinition.toObjectTypeDefinition.pluralForm : associationDefinition.toObjectTypeDefinition.singularForm;
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.associationPopover.viewAllAssociated",
      options: {
        associationName
      }
    })
  });
};
export default ViewAssociatedObjectsLink;